import { ReactComponent as CartIcon } from '../../../../assets/svg/footer-cart.svg';
import styles from './EmptyCart.module.css';

const EmptyCart = () => (
  <div className={`cart-empty-list ${styles.CartEmptyContainer}`}>
    <CartIcon className={styles.CartIcon} />
    <span>سبد خرید شما خالی است</span>
  </div>
);

export default EmptyCart;
